import { default as React, useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import BooleanField from '../../core/components/Fields/BooleanField.tsx';
import TagsField from '../../core/components/Fields/TagsField.tsx';
import FormField from '../../core/components/FormField.tsx';
import SaveStatus from '../../core/components/SaveStatus.tsx';
import SettingsFormCard from '../../core/components/SettingsFormCard.tsx';
import { useToaster } from '../../core/components/Toast.tsx';
import countFieldErrors from '../../core/utils/countFieldErrors.ts';

const FORM_DEFAULT_VALUES = {
    forwardingAddresses: [],
    sendBack: false,
};

const DiscardConfig = ({ config, onActivate, onDeactivate = undefined, onSubmit }) => {
    const { t } = useTranslation('config');
    const { publishToast } = useToaster();

    const form = useForm({ defaultValues: FORM_DEFAULT_VALUES, mode: 'onTouched' });
    const formErrors = form.formState.errors;

    useEffect(() => {
        form.reset({
            forwardingAddresses: config?.forwardingAddresses || [],
            sendBack: config?.sendBack,
        });
    }, [config]);

    const handleSubmit = async (formData) => {
        try {
            if (!config) await onActivate();
            await onSubmit(formData);
            publishToast({ description: t('configPage.discard.updateSuccess'), status: 'success' });
        } catch (e) {
            console.error(e);
            publishToast({ description: t('configPage.discard.updateError'), status: 'error' });
        }
    };

    return (
        <SettingsFormCard onSubmit={form.handleSubmit(handleSubmit)} title={t('configPage.discard.title')}>
            <Controller
                name="forwardingAddresses"
                control={form.control}
                render={({ field }) => (
                    <FormField
                        label={t('configPage.discard.form.forwardingAddresses')}
                        error={formErrors.forwardingAddresses}
                    >
                        <TagsField {...field} onValueChange={field.onChange} />
                    </FormField>
                )}
            />

            <Controller
                name="sendBack"
                control={form.control}
                render={({ field }) => (
                    <FormField label={t('configPage.discard.form.sendBack')} error={formErrors.sendBack}>
                        <BooleanField {...field} value={field.value ? 'true' : ''} />
                    </FormField>
                )}
            />

            <SaveStatus
                isDirty={form.formState.isDirty}
                isSubmitting={form.formState.isSubmitting}
                errorCount={countFieldErrors(form.formState.errors)}
            />
        </SettingsFormCard>
    );
};

export default DiscardConfig;
